import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import FormButtons from '../../../core/form/FormButtons';
import Select from '../../../core/form/Select';
import EditableTable from '../../../core/form/EditableTable';
import Async from '../../../core/layout/Async';
import Tabs from '../../../core/layout/Tabs';

const LocalizationForm = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      <Column size={2}>
        <Select
          options={[
            {
              label: 'New Student Web',
              value: 'NEW_STUDENT_WEB',
            },
            {
              label: 'New Student Mobile',
              value: 'NEW_STUDENT_MOBILE',
            },
            {
              label: 'Student',
              value: 'STUDENT',
            },
            {
              label: 'Kids',
              value: 'KIDS',
            },
            {
              label: 'Parent',
              value: 'PARENT',
            },
            {
              label: 'Push Notifications',
              value: 'PUSH_NOTIFICATIONS',
            },
            {
              label: 'Partner Dashboard',
              value: 'PARTNER_DASHBOARD',
            },
          ]}
          label="Type"
          required
          disabled={props.submitting}
          value={get(props.values, 'type', '')}
          onChange={(value) => props.onChange('type', value)}
          errorText={get(props.errors, 'type', null)}
        />
      </Column>
      <Column size={3}>
        <TextInput
          required
          disabled={props.submitting}
          label="Key"
          value={get(props.values, 'key', '')}
          onChange={(value) => props.onChange('key', value)}
          errorText={get(props.errors, 'key', null)}
        />
      </Column>
    </Row>
    <Row>
      <Tabs
        storeInUrl={false}
        tabs={[{ name: 'Default', id: null }, ...props.segments].map((s) => ({
          key: s.name,
          title: s.name,
          content: (
            <Async fetching={props.submitting}>
              <EditableTable
                columns={[
                  {
                    label: 'Locale',
                    path: 'locale',
                    sort: true,
                    defaultSortOrder: 'ascend',
                    width: '80px',
                  },
                  {
                    label: 'Text',
                    path: 'value',
                    editable: true,
                  },
                ]}
                rows={get(props.values, 'translations', []).filter((t) => (!s.id ? !t.segment : t.segment === s.id))}
                rowKey="locale"
                pagination={false}
                onSave={(row, change) => {
                  // const translations = JSON.parse(JSON.stringify(get(props.values, 'translations')));
                  const translations = get(props.values, 'translations');
                  const translation = translations.find(
                    (translation) =>
                      translation.locale === row.locale && (!s.id ? !translation.segment : translation.segment === s.id)
                  );
                  translation.value = change.value.trim();
                  props.onChange('translations', translations);
                }}
              />
            </Async>
          ),
        }))}
      />
    </Row>
    <br />
    <FormButtons
      confirmLabel={props.values.id ? 'Update Localization' : 'Create Localization'}
      isDisabled={props.submitting || !props.isDirty()}
      isSubmitting={props.submitting}
      onReset={props.onReset}
    />
  </form>
);

LocalizationForm.propTypes = {
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
  segments: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, id: PropTypes.string })),
};

LocalizationForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  isDirty: () => false,
  onSubmit: () => alert('submitted'),
  onReset: () => false,
};

export default LocalizationForm;
